import React, { useState, useEffect, useRef } from 'react';
import '../App.css';
import { useHistory, useLocation } from 'react-router-dom';
import { Form, Button, Input } from 'reactstrap';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import MyLoader from './util/loader';
import MyStorage from './util/storage';
import Api from './api/api';
import showToast from './util/toast';
import { ToastContainer } from 'react-toastify';
import GLOBAL from '../global.js';

const SettingsPro = () => {
    const history = useHistory()
    const location = useLocation()
    let filePath = MyStorage.getFileUrls().LibraryImages;

    const [loader, setLoader] = useState(false);

    const [screenTxt, setScreenTxt] = useState('');
    const [memberTxt, setMemberTxt] = useState('');
    const [proTxt, setProTxt] = useState('');
    const [clientTxt, setClientTxt] = useState('');

    const [mainShots, setMainShots] = useState([null, null, null]);
    const [mainShotUrls, setMainShotUrls] = useState([null, null, null]);
    const [videoShots, setVideoShots] = useState([null, null, null]);
    const [videoShotUrls, setVideoShotUrls] = useState([null, null, null]);

    const addMainShot1 = useRef(null);
    const addMainShot2 = useRef(null);
    const addMainShot3 = useRef(null);
    const addVideoShot1 = useRef(null);
    const addVideoShot2 = useRef(null);
    const addVideoShot3 = useRef(null);

    useEffect(() => {
        loadSettings()

        // load temp upload
        let tempUploadedProVideoName = GLOBAL.tempUploadedProVideoName
        let tempUploadedProVideoIndex = GLOBAL.tempUploadedProVideoIndex
        if (tempUploadedProVideoName != null) {
            console.log('tempUploadedProVideoName: ' + tempUploadedProVideoName);
            console.log('tempUploadedProVideoIndex: ' + tempUploadedProVideoIndex);
            let urls = GLOBAL.proSettings.videoShotUrls
            urls[tempUploadedProVideoIndex] = tempUploadedProVideoName
            console.log('URLS: ' + urls);
            // save api
            saveChanges(urls)

            // reset
            GLOBAL.tempUploadedProVideoName = null
            GLOBAL.tempUploadedProVideoIndex = -1
        }

    }, [])

    const loadSettings = () => {
        setLoader(true)
        Api.getSettings(
            (response) => {
                setLoader(false)
                console.log('' + JSON.stringify(response));
                let settings = response.data
                let videoUrls = [null, null, null]
                let thumbUrls = [null, null, null]
                for (let i = 0; i < settings.length; i++) {
                    const row = settings[i];

                    if (row.type === 'pro_screen_text') {
                        setScreenTxt(row.text)
                    }
                    else if (row.type === 'member_text') {
                        setMemberTxt(row.text)
                    }
                    else if (row.type === 'pro_text') {
                        setProTxt(row.text)
                    }
                    else if (row.type === 'client_text') {
                        setClientTxt(row.text)
                    }

                    else if (row.type === 'member_video') {
                        videoUrls[0] = row.text
                    }
                    else if (row.type === 'pro_video') {
                        videoUrls[1] = row.text
                    }
                    else if (row.type === 'client_video') {
                        videoUrls[2] = row.text
                    }

                    else if (row.type === 'member_video_thumb') {
                        thumbUrls[0] = row.text
                    }
                    else if (row.type === 'pro_video_thumb') {
                        thumbUrls[1] = row.text
                    }
                    else if (row.type === 'client_video_thumb') {
                        thumbUrls[2] = row.text
                    }
                }
                setVideoShotUrls(videoUrls)
                setMainShotUrls(thumbUrls)
            },
            (error) => {
                setLoader(false)
            });
    };

    const saveChanges = (videoShotUrls) => {
        if (GLOBAL.proSettings == null)
            return

        console.log('proSettings: ' + JSON.stringify(GLOBAL.proSettings));
        console.log('videoShotUrls: ' + JSON.stringify(videoShotUrls));

        let screenTxt = GLOBAL.proSettings.screenTxt
        let memberTxt = GLOBAL.proSettings.memberTxt
        let proTxt = GLOBAL.proSettings.proTxt
        let clientTxt = GLOBAL.proSettings.clientTxt
        let mainShots = GLOBAL.proSettings.mainShots
        let videoShots = GLOBAL.proSettings.videoShots

        if (screenTxt === '' || memberTxt === '' || proTxt === '' || clientTxt === '') {
            showToast('error', 'Please fill the form')
            return
        }

        setLoader(true)

        let memberVideoName = videoShotUrls[0] !== '' && videoShotUrls[0] != null && !videoShotUrls[0].includes('https://') ? videoShotUrls[0] : ''
        let proVideoName = videoShotUrls[1] !== '' && videoShotUrls[1] != null && !videoShotUrls[1].includes('https://') ? videoShotUrls[1] : ''
        let clientVideoName = videoShotUrls[2] !== '' && videoShotUrls[2] != null && !videoShotUrls[2].includes('https://') ? videoShotUrls[2] : ''

        Api.saveProSettings(screenTxt, memberTxt, proTxt, clientTxt, memberVideoName, proVideoName, clientVideoName, mainShots[0], mainShots[1], mainShots[2],
            (response) => {
                setLoader(false)
                console.log('' + JSON.stringify(response));
                if (response.status === 'success') {
                    showToast('success', 'Data Saved!')
                }
            },
            (error) => {
                setLoader(false)
            });
    };

    const uploadVideo = (index) => {
        GLOBAL.proSettings = {
            screenTxt: screenTxt,
            memberTxt: memberTxt,
            proTxt: proTxt,
            clientTxt: clientTxt,
            mainShots: mainShots,
            mainShotUrls: mainShotUrls,
            videoShots: videoShots,
            videoShotUrls: videoShotUrls
        }
        GLOBAL.tempUploadedProVideoIndex = index
        history.push({
            pathname: "/upload-videos",
            state: { model: null, guide: false, settings_pro: true },
        });
    };

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Professionals Settings
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 15 }}>
                <Form className="form" style={{ width: 600, marginTop: 20, backgroundColor: '#f2f2f2' }}>

                    <div style={{ marginTop: 10, marginBottom: 5, fontWeight: 'bold' }}>Screen Text</div>
                    <Input
                        style={{ marginTop: 0, height: 70, fontSize: 16 }}
                        type='textarea'
                        placeholder=''
                        value={screenTxt}
                        onChange={(event) => {
                            setScreenTxt(event.target.value)
                        }} />

                    <div style={{ width: '100%', height: 1, backgroundColor: 'lightgray', marginTop: 15 }} />

                    <div style={{ marginTop: 10, marginBottom: 5, fontWeight: 'bold' }}>Become a Member Section</div>
                    <Input
                        style={{ marginTop: 0, height: 70, fontSize: 16 }}
                        type='textarea'
                        placeholder='Enter custom text...'
                        value={memberTxt}
                        onChange={(event) => {
                            setMemberTxt(event.target.value)
                        }} />

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <div style={{ width: 130, height: 100, backgroundColor: 'lightgray', marginTop: 10, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                                {/* <img
                                    src={null}
                                    style={{ width: 130, height: 100, objectFit: 'conver', backgroundColor: 'lightgray' }} /> */}
                                <div style={{ fontSize: 12, color: 'blue', marginTop: 10 }}>
                                    {videoShotUrls[0] == null ? 'No File Chosen' : videoShotUrls[0].substring(0, 9) + '...'}
                                </div>
                            </div>
                            <Button
                                style={{ marginTop: 0, fontSize: 13, width: 130, borderRadius: 0 }}
                                className='btn-block'
                                onClick={() => {
                                    uploadVideo(0)
                                }}>
                                Choose Video
                            </Button>
                        </div>
                        <div style={{ marginLeft: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <div style={{ width: 130, height: 100, backgroundColor: 'lightgray', marginTop: 10, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                                {mainShotUrls[0] != null ?
                                    <img
                                        src={mainShotUrls[0]}
                                        style={{ width: 130, height: 100, objectFit: 'contain', backgroundColor: 'lightgray' }} />
                                    :
                                    <div style={{ fontSize: 12, color: 'blue', marginTop: 10 }}>No File Chosen</div>
                                }
                            </div>
                            <input
                                type='file'
                                style={{ display: 'none' }}
                                ref={addMainShot1}
                                onChange={(event) => {
                                    let index = 0
                                    const shots = [...mainShots]
                                    shots[index] = event.target.files[0]
                                    setMainShots(shots);
                                    const urls = [...mainShotUrls]
                                    urls[index] = URL.createObjectURL(event.target.files[0])
                                    setMainShotUrls(urls)
                                }} />
                            {/* <input
                                type='file'
                                style={{ display: 'none' }}
                                ref={addVideoShot1}
                                onChange={(event) => {
                                    let index = 0
                                    const shots = [...videoShots]
                                    shots[index] = event.target.files[0]
                                    setVideoShots(shots);
                                    const urls = [...videoShotUrls]
                                    urls[index] = URL.createObjectURL(event.target.files[0])
                                    setVideoShotUrls(urls)
                                }} /> */}
                            <Button
                                style={{ marginTop: 0, fontSize: 13, width: 130, borderRadius: 0 }}
                                className='btn-block'
                                onClick={() => {
                                    addMainShot1.current.click();
                                }}>
                                Choose Thumb
                            </Button>
                        </div>
                    </div>

                    <div style={{ width: '100%', height: 1, backgroundColor: 'lightgray', marginTop: 15 }} />

                    <div style={{ marginTop: 10, marginBottom: 5, fontWeight: 'bold' }}>Pro Membership Section</div>
                    <Input
                        style={{ marginTop: 0, height: 70, fontSize: 16 }}
                        type='textarea'
                        placeholder='Enter custom text...'
                        value={proTxt}
                        onChange={(event) => {
                            setProTxt(event.target.value)
                        }} />

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <div style={{ width: 130, height: 100, backgroundColor: 'lightgray', marginTop: 10, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                                {/* <img
                                src={null}
                                style={{ width: 130, height: 100, objectFit: 'conver', backgroundColor: 'lightgray' }} /> */}
                                <div style={{ fontSize: 12, color: 'blue', marginTop: 10 }}>
                                    {videoShotUrls[1] == null ? 'No File Chosen' : videoShotUrls[1].substring(0, 9) + '...'}
                                </div>
                            </div>
                            <Button
                                style={{ marginTop: 0, fontSize: 13, width: 130, borderRadius: 0 }}
                                className='btn-block'
                                onClick={() => {
                                    uploadVideo(1)
                                }}>
                                Choose Video
                            </Button>
                        </div>
                        <div style={{ marginLeft: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <div style={{ width: 130, height: 100, backgroundColor: 'lightgray', marginTop: 10, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                                {mainShotUrls[1] != null ?
                                    <img
                                        src={mainShotUrls[1]}
                                        style={{ width: 130, height: 100, objectFit: 'contain', backgroundColor: 'lightgray' }} />
                                    :
                                    <div style={{ fontSize: 12, color: 'blue', marginTop: 10 }}>No File Chosen</div>
                                }
                            </div>
                            <input
                                type='file'
                                style={{ display: 'none' }}
                                ref={addMainShot2}
                                onChange={(event) => {
                                    let index = 1
                                    const shots = [...mainShots]
                                    shots[index] = event.target.files[0]
                                    setMainShots(shots);
                                    const urls = [...mainShotUrls]
                                    urls[index] = URL.createObjectURL(event.target.files[0])
                                    setMainShotUrls(urls)
                                }} />
                            {/* <input
                                type='file'
                                style={{ display: 'none' }}
                                ref={addVideoShot2}
                                onChange={(event) => {
                                    let index = 1
                                    const shots = [...videoShots]
                                    shots[index] = event.target.files[0]
                                    setVideoShots(shots);
                                    const urls = [...videoShotUrls]
                                    urls[index] = URL.createObjectURL(event.target.files[0])
                                    setVideoShotUrls(urls)
                                }} /> */}
                            <Button
                                style={{ marginTop: 0, fontSize: 13, width: 130, borderRadius: 0 }}
                                className='btn-block'
                                onClick={() => {
                                    addMainShot2.current.click();
                                }}>
                                Choose Thumb
                            </Button>
                        </div>
                    </div>

                    <div style={{ width: '100%', height: 1, backgroundColor: 'lightgray', marginTop: 15 }} />

                    <div style={{ marginTop: 10, marginBottom: 5, fontWeight: 'bold' }}>Client Membership Section</div>
                    <Input
                        style={{ marginTop: 0, height: 70, fontSize: 16 }}
                        type='textarea'
                        placeholder='Enter custom text...'
                        value={clientTxt}
                        onChange={(event) => {
                            setClientTxt(event.target.value)
                        }} />

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <div style={{ width: 130, height: 100, backgroundColor: 'lightgray', marginTop: 10, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                                {/* <img
                                    src={null}
                                    style={{ width: 130, height: 100, objectFit: 'conver', backgroundColor: 'lightgray' }} /> */}
                                <div style={{ fontSize: 12, color: 'blue', marginTop: 10 }}>
                                    {videoShotUrls[2] == null ? 'No File Chosen' : videoShotUrls[2].substring(0, 9) + '...'}
                                </div>
                            </div>
                            <Button
                                style={{ marginTop: 0, fontSize: 13, width: 130, borderRadius: 0 }}
                                className='btn-block'
                                onClick={() => {
                                    uploadVideo(2)
                                }}>
                                Choose Video
                            </Button>
                        </div>
                        <div style={{ marginLeft: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <div style={{ width: 130, height: 100, backgroundColor: 'lightgray', marginTop: 10, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                                {mainShotUrls[2] != null ?
                                    <img
                                        src={mainShotUrls[2]}
                                        style={{ width: 130, height: 100, objectFit: 'contain', backgroundColor: 'lightgray' }} />
                                    :
                                    <div style={{ fontSize: 12, color: 'blue', marginTop: 10 }}>No File Chosen</div>
                                }
                            </div>
                            <input
                                type='file'
                                style={{ display: 'none' }}
                                ref={addMainShot3}
                                onChange={(event) => {
                                    let index = 2
                                    const shots = [...mainShots]
                                    shots[index] = event.target.files[0]
                                    setMainShots(shots);
                                    const urls = [...mainShotUrls]
                                    urls[index] = URL.createObjectURL(event.target.files[0])
                                    setMainShotUrls(urls)
                                }} />
                            {/* <input
                                type='file'
                                style={{ display: 'none' }}
                                ref={addVideoShot3}
                                onChange={(event) => {
                                    let index = 2
                                    const shots = [...videoShots]
                                    shots[index] = event.target.files[0]
                                    setVideoShots(shots);
                                    const urls = [...videoShotUrls]
                                    urls[index] = URL.createObjectURL(event.target.files[0])
                                    setVideoShotUrls(urls)
                                }} /> */}
                            <Button
                                style={{ marginTop: 0, fontSize: 13, width: 130, borderRadius: 0 }}
                                className='btn-block'
                                onClick={() => {
                                    addMainShot3.current.click();
                                }}>
                                Choose Thumb
                            </Button>
                        </div>
                    </div>


                    <Button
                        style={{ marginTop: 20, fontSize: 16 }}
                        className='btn-block btn-dark'
                        onClick={() => {
                            GLOBAL.proSettings = {
                                screenTxt: screenTxt,
                                memberTxt: memberTxt,
                                proTxt: proTxt,
                                clientTxt: clientTxt,
                                mainShots: mainShots,
                                mainShotUrls: mainShotUrls,
                                videoShots: videoShots,
                                videoShotUrls: videoShotUrls
                            }
                            saveChanges(videoShotUrls)
                        }}>
                        Save Changes
                    </Button>

                </Form>
            </div>
            <MyLoader loader={loader} />
            <div>
                <ToastContainer />
            </div>
        </div>
    );
}

export default SettingsPro;